import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { PairInfo } from "@/types";
import { OpenOrdersGrid } from "./OpenOrdersGrid";

type OpenTradesMetricsProps = {
  openPositions: number;
  pairs: PairInfo[];
};

export const OpenTradesMetrics = ({ openPositions, pairs }: OpenTradesMetricsProps): React.ReactNode => {
  // Find the pair with the most open orders
  const highestPair = pairs.length > 0
    ? pairs.reduce((max, pair) => (pair.openOrders ?? 0) > (max.openOrders ?? 0) ? pair : max, pairs[0])
    : null;
  const highestCount = highestPair?.openOrders ?? 0;
  const highestSymbol = highestPair?.symbol?.replace('.PRO', '') ?? '';
  const activePairsCount = pairs.filter(p => (p.openOrders ?? 0) > 0).length;

  return (
    <Card x-chunk="dashboard-05-chunk-1" className="flex flex-col h-full">
      <CardHeader className="pb-2">
        <CardDescription>Open Trades</CardDescription>
        <CardTitle className="text-6xl font-bold">{openPositions}</CardTitle>
      </CardHeader>
      <CardContent className="pb-4 flex flex-col gap-2 mt-auto">
        <OpenOrdersGrid
          pairs={pairs}
          totalOpenOrders={openPositions}
          label={highestCount > 0 ? (
            <div className="flex justify-between text-xs text-muted-foreground mb-2">
              <span>{activePairsCount} pairs</span>
              <span>{highestCount} in {highestSymbol}</span>
            </div>
          ) : undefined}
        />
      </CardContent>
    </Card>
  );
};
